import Vue from 'vue'
import $ from 'jquery'
// import store from '@/store'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
   return originalPush.call(this, location).catch(err => {
      if (VueRouter.isNavigationFailure ? VueRouter.isNavigationFailure(err, 16) : (err && err.name === 'NavigationDuplicated')) {
         return err
      }
      return Promise.reject(err)
   })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
   if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
   return originalReplace.call(this, location).catch(err => {
      if (VueRouter.isNavigationFailure ? VueRouter.isNavigationFailure(err, 16) : (err && err.name === 'NavigationDuplicated')) {
         return err
      }
      return Promise.reject(err)
   })
}

const routes = [
   { path: '/planos/tabelas', name: 'Tabelas de preços', component: () => import('../views/commercial/CommercialManagement.vue'), props: { resource: 'tables' }, meta: { requireAuth: true, icon: 'bx bx-folder' } },
   { path: '/representantes/usuarios', name: 'Usuários do representante', component: () => import('../views/commercial/CommercialManagement.vue'), props: { resource: 'panelUsers' }, meta: { requireAuth: true, icon: 'bx bx-folder' } },
   { path: '/empresas/gestores', name: 'Gestores', component: () => import('../views/commercial/CommercialManagement.vue'), props: { resource: 'managers' }, meta: { requireAuth: true, icon: 'bx bx-folder' } },
   { path: '/empresas/grupos', name: 'Grupos empresariais', component: () => import('../views/commercial/CommercialManagement.vue'), props: { resource: 'businessGroups' }, meta: { requireAuth: true, icon: 'bx bx-folder' } },
   { path: '/contabilidades', name: 'Contabilidades', component: () => import('../views/commercial/CommercialManagement.vue'), props: { resource: 'accountingOffices' }, meta: { requireAuth: true, icon: 'bx bx-calculator' } },
   { path: '/contabilidades/usuarios', name: 'Usuários contábeis', component: () => import('../views/commercial/CommercialManagement.vue'), props: { resource: 'accountingUsers' }, meta: { requireAuth: true, icon: 'bx bx-user' } },
   { path: '/empresas/contabilidades', redirect: '/contabilidades' },
   { path: '/empresas/usuarios-contabeis', redirect: '/contabilidades/usuarios' },
   {
      path: '/gestao-comercial',
      name: 'Gestão comercial',
      redirect: '/empresas',
      meta: { requireAuth: true, icon: 'bx bx-network-chart' }
   },
   {
      path: '/paginaInicial',
      name: 'Página_inicial',
      component: () => import('../views/PaginaInicial.vue'),
      meta: {'icon': 'bx bx-home-circle'}
   },
   {
      path: '/perfil',
      name: 'Perfil',
      component: () => import('../views/perfil/Perfil.vue'),
      meta: {'icon': 'bx bx-user'}
   },
   {
      path: '/representantes',
      name: 'Representantes',
      component: () => import('../views/commercial/CommercialManagement.vue'),
      props: { resource: 'representatives' },
      meta: {'icon': 'bx bx-id-card'}
   },
   {
      path: '/representantes/logs',
      name: 'Logs Representantes',
      component: () => import('../views/representantes/Logs.vue'),
      meta: {'icon': 'bx bx-log-in'}
   },
   {
      path: '/planos',
      name: 'Planos',
      component: () => import('../views/commercial/CommercialManagement.vue'),
      props: { resource: 'plans' },
      meta: {'icon': 'bx bx-money'}
   },
   {
      path: '/planos/logs',
      name: 'Logs Planos',
      component: () => import('../views/planos/Logs.vue'),
      meta: {'icon': 'bx bx-log-in'}
   },
   {
      path: '/empresas',
      name: 'Empresas',
      component: () => import('../views/commercial/CommercialManagement.vue'),
      props: { resource: 'companies' },
      meta: {'icon': 'bx bx-building'}
   },
   {
      path: '/empresas/logs',
      name: 'Logs Empresas',
      component: () => import('../views/empresas/Logs.vue'),
      meta: {'icon': 'bx bx-log-in'}
   },
   {
      path: '/assinaturas',
      name: 'Assinaturas',
      component: () => import('../views/commercial/CommercialManagement.vue'),
      props: { resource: 'subscriptions' },
      meta: {'icon': 'bx bx-building'}
   },
   {
      path: '/assinaturas/logs',
      name: 'Logs Assinaturas',
      component: () => import('../views/assinaturas/Logs.vue'),
      meta: {'icon': 'bx bx-log-in'}
   },
   {
      path: '/relatorios',
      name: 'Relatórios',
      component: () => import('../views/relatorios/RelatoriosDashboard.vue'),
      meta: {'icon': 'bx bx-bar-chart-alt-2'}
   },
   {
      path: '/relatorios-dinamicos',
      name: 'Relatórios Dinâmicos',
      component: () => import('../views/relatorios/RelatorioDinamico.vue'),
      meta: {'icon': 'bx bx-chart'}
   },
   {
      path: '/changelog',
      name: 'Changelog',
      component: () => import('../views/changelog/Changelog.vue'),
      meta: {'icon': 'bx bx-history'}
   },
   {
      path: '/assinaturas/faturamento',
      name: 'Faturamento de Assinaturas',
      component: () => import('../views/assinaturas/Faturamento.vue'),
      meta: {'icon': 'bx bx-money'}
   },
   {
      path: '/assinaturas/solicitacoes',
      name: 'Solicitações de Alteração',
      component: () => import('../views/assinaturas/Solicitacoes.vue'),
      meta: {'icon': 'bx bx-message-detail'}
   },
   {
      path: '/tutoriais',
      name: 'Tutoriais',
      component: () => import('../views/tutoriais/Tutoriais.vue'),
      meta: {'icon': 'bx bx-video'}
   },
   {
      path: '/atualizacoes',
      name: 'Atualizações',
      component: () => import('../views/atualizacoes/AtualizacoesSistema.vue'),
      meta: {'icon': 'bx bx-sync'}
   },
   {
      path: '/sistema/reportar-suporte',
      name: 'ReportForm',
      component: () => import('../views/sistema/support/ReportForm.vue'),
      meta: { requireAuth: true, pageTitle: 'Suporte / Report' }
   },
   {
      path: '/sistema/suporte/tickets',
      name: 'TicketList',
      component: () => import('../views/sistema/support/TicketList.vue'),
      meta: { requireAuth: true, pageTitle: 'Meus Tickets' }
   }
]

const router = new VueRouter({
   mode: 'abstract',
   base: process.env.BASE_URL,
   routes
})

import { canUserAccessPath } from '@/services/commercial/panelPermissions'

router.beforeEach((to, from, next) => {
   try {
      const store = require('@/store').default
      const user = store?.state?.dadosUsuario
      if (store?.state?.isLogado && user) {
         if (!canUserAccessPath(user, to.path)) {
            if (to.path !== '/paginaInicial') {
               return next('/paginaInicial')
            }
         }
      }
   } catch (e) {
      console.warn('Erro na verificação de permissões da rota:', e)
   }
   next()
})

/* eslint-disable-next-line no-unused-vars */
router.beforeResolve((to, from, next) => {
   if (window.matchMedia("(max-width: 1024px)").matches) $("#app > .wrapper").removeClass("toggled");
   $("#main-content").animate({scrollTop: 0}, 0);
   next()
})

export default router
